var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ability-wrapper",attrs:{"id":"croll-board"}},[_c('div',{staticClass:"ability-box bg-color-black"},[_c('div',{staticClass:"info-box"},[_c('div',{staticClass:"title"},[_vm._v("学习能力")]),_c('div',{staticClass:"desc"},[_vm._v("该生求职课程学习情况展示")]),_c('dv-scroll-board',{staticClass:"table-box",attrs:{"config":_vm.config}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }